/**
 * analytics.js — Kenaz GTM / GA4 utility
 *
 * Exposes window.user_engagement() so any Shopify theme JS can push a
 * normalised "user_engagement" event into the GTM dataLayer.
 *
 * Usage:
 *   user_engagement({ action: 'viewed', object: 'note_card', sub_params: { note_name: 'Oud' } });
 */

window.dataLayer = window.dataLayer || [];

function _kenazTimestamp() {
  var d = new Date();
  var pad = function (n) { return String(n).padStart(2, '0'); };
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
    + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
}

window.user_engagement = function (params) {
  var action     = params.action;
  var object     = params.object;
  var sub_params = params.sub_params || {};

  var payload = {
    event:     'user_engagement',
    action:    action,
    object:    object,
    timestamp: _kenazTimestamp(),
    page:      window.location.pathname
  };

  // Merge any extra sub_params into the payload
  Object.keys(sub_params).forEach(function (key) {
    payload[key] = sub_params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] user_engagement', {
      action:     action,
      object:     object,
      sub_params: sub_params
    });
  }
};

/**
 * window.click_event(eventName, params)
 *
 * DEPRECATED: Use specific event functions below instead.
 * Kept for backward compatibility.
 */
window.click_event = function (eventName, params) {
  params = params || {};

  var payload = {
    event:      'click_event',
    event_name: eventName,
    timestamp:  _kenazTimestamp(),
    page:       window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] click_event', { event_name: eventName, params: params });
  }
};

/**
 * scroll_event — Scroll depth tracking
 * Usage: scroll_event({ depth_percentage: 25, time_to_scroll_ms: 1500 });
 */
window.scroll_event = function (params) {
  params = params || {};

  var payload = {
    event:     'scroll_event',
    timestamp: _kenazTimestamp(),
    page:      window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] scroll_event', params);
  }
};

/**
 * navigation_menu — Header navigation clicks (hamburger, cart, search)
 * Usage: navigation_menu('cart_icon_clicked', { cart_item_count: 2 });
 */
window.navigation_menu = function (eventName, params) {
  params = params || {};

  var payload = {
    event:      'navigation_menu',
    event_name: eventName,
    timestamp:  _kenazTimestamp(),
    page:       window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] navigation_menu', { event_name: eventName, params: params });
  }
};

/**
 * share_event — Share button clicks
 * Usage: share_event({ platform: 'whatsapp', product_name: 'Oud' });
 */
window.share_event = function (params) {
  params = params || {};

  var payload = {
    event:     'share_event',
    timestamp: _kenazTimestamp(),
    page:      window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] share_event', params);
  }
};

/**
 * review_event — Review section clicks (star widget, see all)
 * Usage: review_event({ click_source: 'star_widget', rating: 4.5 });
 */
window.review_event = function (params) {
  params = params || {};

  var payload = {
    event:     'review_event',
    timestamp: _kenazTimestamp(),
    page:      window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] review_event', params);
  }
};

/**
 * qty_event — Quantity button clicks (plus/minus)
 * Usage: qty_event({ action: 'increase', product_sku: 'ABC123', new_qty: 2 });
 */
window.qty_event = function (params) {
  params = params || {};

  var payload = {
    event:     'qty_event',
    timestamp: _kenazTimestamp(),
    page:      window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] qty_event', params);
  }
};

/**
 * byob_event — Build Your Own Box page events
 * Usage: byob_event('add_to_box_clicked', { product_sku: 'ABC', box_position: 1 });
 */
window.byob_event = function (eventName, params) {
  params = params || {};

  var payload = {
    event:      'byob_event',
    event_name: eventName,
    timestamp:  _kenazTimestamp(),
    page:       window.location.pathname
  };

  Object.keys(params).forEach(function (key) {
    payload[key] = params[key];
  });

  window.dataLayer.push(payload);

  if (typeof console !== 'undefined' && console.log) {
    console.log('[Kenaz Analytics] byob_event', { event_name: eventName, params: params });
  }
};
